import { render, staticRenderFns } from "./admin-listing.vue?vue&type=template&id=1497e7f4&scoped=true"
import script from "./admin-listing.vue?vue&type=script&lang=js"
export * from "./admin-listing.vue?vue&type=script&lang=js"
import style0 from "./admin-listing.vue?vue&type=style&index=0&id=1497e7f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497e7f4",
  null
  
)

export default component.exports